import { useContext, useEffect, useState } from "react";
import { createContext } from "react";
import { fetchadmininfo } from "../../Redux/Actions/AdmininfoAction";
import { useDispatch } from "react-redux";
import { _get } from "../../../apiClient";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  let loaderTimeout;
  const dispatch = useDispatch();

  const [PackageParam, setPackageParam] = useState(null);
  const [username, setUsername] = useState(null);
  const [PackagesCartItems, setPackagesCartItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [title, setTitle] = useState("");
  const [pageIcon, setPageIcon] = useState("");

  const storeTokens = (accessToken, refreshToken) => {
    if (localStorage.getItem("token")) localStorage.removeItem("token");

    if (localStorage.getItem("refresh_token"))
      localStorage.removeItem("refresh_token");

    localStorage.setItem("token", accessToken);
    localStorage.setItem("refresh_token", refreshToken);

    return;
  };

  const getToken = () => {
    return localStorage.getItem("token");
  };

  const logoutuser = () => {
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("token");
    localStorage.setItem("isAuthenticated", false);
    window.location.href = "/login";
  };

  const storePackageParam = (value) => {
    setPackageParam(value);
  };

  const showLoader = (message = "") => {
    clearTimeout(loaderTimeout);
    setLoadingMessage(message);
    setLoading(true);
  };

  const hideLoader = () => {
    loaderTimeout = setTimeout(() => {
      setLoadingMessage("");
      setLoading(false);
    }, 500); // Ensure loader is displayed for at least 1 second
  };

  const userAuthentication = async () => {
    let authenticated = localStorage.getItem("token");
    if (authenticated) {
      await fetchUserDetails();
    }
  };

  const fetchUserDetails = async () => {
    await _get("/app-users/details")
      .then((response) => {
        dispatch(fetchadmininfo(response));
      })
      .catch((error) => {
        localStorage.setItem("isAuthenticated", false);
      });
  };

  const login = () => {
    return localStorage.setItem("isAuthenticated", true);
  };

  useEffect(() => {
    if (window.location.pathname != "/register") userAuthentication();
  }, []);

  const updateTitleAndIcon = (title, icon) => {
    setTitle(title);
    setPageIcon(icon);
    document.title = title + " | Invitd";
  };

  return (
    <AuthContext.Provider
      value={{
        storeTokens,
        logoutuser,
        login,
        storePackageParam,
        setPackagesCartItems,
        showLoader,
        hideLoader,
        getToken,
        updateTitleAndIcon,
        fetchUserDetails,
        PackageParam,
        PackagesCartItems,
        loading,
        loadingMessage,
        title,
        pageIcon,
        username,
        setUsername,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const authContext = useContext(AuthContext);
  if (!authContext) {
    throw new Error("useAuth used outside of the Provider");
  }
  return authContext;
};
